export const getStateByName = ({ updatingBlocks = {}}, name) => updatingBlocks[name]
